module.exports = __webpack_public_path__ + "img/wolf.be5030ca.webp";